@file:OptIn(InternalResourceApi::class)

package portfolio.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/portfolio.shared.generated.resources/"

@delegate:ResourceContentHash(-1_873_362_992)
internal val Res.font.outfit_black: FontResource by lazy {
      FontResource("font:outfit_black", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_black.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-871_168_809)
internal val Res.font.outfit_bold: FontResource by lazy {
      FontResource("font:outfit_bold", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(610_742_158)
internal val Res.font.outfit_extrabold: FontResource by lazy {
      FontResource("font:outfit_extrabold", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_extrabold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_696_797_619)
internal val Res.font.outfit_extralight: FontResource by lazy {
      FontResource("font:outfit_extralight", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_extralight.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-363_403_004)
internal val Res.font.outfit_light: FontResource by lazy {
      FontResource("font:outfit_light", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_446_232_672)
internal val Res.font.outfit_medium: FontResource by lazy {
      FontResource("font:outfit_medium", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_824_112_481)
internal val Res.font.outfit_regular: FontResource by lazy {
      FontResource("font:outfit_regular", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_047_820_600)
internal val Res.font.outfit_semibold: FontResource by lazy {
      FontResource("font:outfit_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_semibold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-349_733_733)
internal val Res.font.outfit_thin: FontResource by lazy {
      FontResource("font:outfit_thin", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_thin.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_095_133_912)
internal val Res.font.poppins_black: FontResource by lazy {
      FontResource("font:poppins_black", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_black.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_536_644_297)
internal val Res.font.poppins_black_italic: FontResource by lazy {
      FontResource("font:poppins_black_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_black_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-317_912_413)
internal val Res.font.poppins_bold: FontResource by lazy {
      FontResource("font:poppins_bold", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_000_949_100)
internal val Res.font.poppins_bold_italic: FontResource by lazy {
      FontResource("font:poppins_bold_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_bold_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_168_950_066)
internal val Res.font.poppins_extra_bold: FontResource by lazy {
      FontResource("font:poppins_extra_bold", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_extra_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(928_280_134)
internal val Res.font.poppins_extra_bold_italic: FontResource by lazy {
      FontResource("font:poppins_extra_bold_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_extra_bold_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-496_313_929)
internal val Res.font.poppins_extra_light: FontResource by lazy {
      FontResource("font:poppins_extra_light", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_extra_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_119_530_635)
internal val Res.font.poppins_extra_light_italic: FontResource by lazy {
      FontResource("font:poppins_extra_light_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_extra_light_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-644_749_075)
internal val Res.font.poppins_italic: FontResource by lazy {
      FontResource("font:poppins_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_829_262_043)
internal val Res.font.poppins_light: FontResource by lazy {
      FontResource("font:poppins_light", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-101_667_350)
internal val Res.font.poppins_light_italic: FontResource by lazy {
      FontResource("font:poppins_light_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_light_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_933_769_947)
internal val Res.font.poppins_medium: FontResource by lazy {
      FontResource("font:poppins_medium", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_063_373_544)
internal val Res.font.poppins_medium_italic: FontResource by lazy {
      FontResource("font:poppins_medium_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_medium_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(992_584_762)
internal val Res.font.poppins_regular: FontResource by lazy {
      FontResource("font:poppins_regular", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(429_221_087)
internal val Res.font.poppins_semi_bold: FontResource by lazy {
      FontResource("font:poppins_semi_bold", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_semi_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_339_413_433)
internal val Res.font.poppins_semi_bold_italic: FontResource by lazy {
      FontResource("font:poppins_semi_bold_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_semi_bold_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-197_762_803)
internal val Res.font.poppins_thin: FontResource by lazy {
      FontResource("font:poppins_thin", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_thin.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_541_322_515)
internal val Res.font.poppins_thin_italic: FontResource by lazy {
      FontResource("font:poppins_thin_italic", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_thin_italic.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("outfit_black", Res.font.outfit_black)
  map.put("outfit_bold", Res.font.outfit_bold)
  map.put("outfit_extrabold", Res.font.outfit_extrabold)
  map.put("outfit_extralight", Res.font.outfit_extralight)
  map.put("outfit_light", Res.font.outfit_light)
  map.put("outfit_medium", Res.font.outfit_medium)
  map.put("outfit_regular", Res.font.outfit_regular)
  map.put("outfit_semibold", Res.font.outfit_semibold)
  map.put("outfit_thin", Res.font.outfit_thin)
  map.put("poppins_black", Res.font.poppins_black)
  map.put("poppins_black_italic", Res.font.poppins_black_italic)
  map.put("poppins_bold", Res.font.poppins_bold)
  map.put("poppins_bold_italic", Res.font.poppins_bold_italic)
  map.put("poppins_extra_bold", Res.font.poppins_extra_bold)
  map.put("poppins_extra_bold_italic", Res.font.poppins_extra_bold_italic)
  map.put("poppins_extra_light", Res.font.poppins_extra_light)
  map.put("poppins_extra_light_italic", Res.font.poppins_extra_light_italic)
  map.put("poppins_italic", Res.font.poppins_italic)
  map.put("poppins_light", Res.font.poppins_light)
  map.put("poppins_light_italic", Res.font.poppins_light_italic)
  map.put("poppins_medium", Res.font.poppins_medium)
  map.put("poppins_medium_italic", Res.font.poppins_medium_italic)
  map.put("poppins_regular", Res.font.poppins_regular)
  map.put("poppins_semi_bold", Res.font.poppins_semi_bold)
  map.put("poppins_semi_bold_italic", Res.font.poppins_semi_bold_italic)
  map.put("poppins_thin", Res.font.poppins_thin)
  map.put("poppins_thin_italic", Res.font.poppins_thin_italic)
}
